export function format(iso: string): string {
  try {
    const d = new Date(iso)
    // Padrão UTC: YYYY-MM-DD HH:mm:ss UTC
    const pad = (n: number) => String(n).padStart(2, '0')
    const y = d.getUTCFullYear()
    const m = pad(d.getUTCMonth() + 1)
    const day = pad(d.getUTCDate())
    const hh = pad(d.getUTCHours())
    const mm = pad(d.getUTCMinutes())
    const ss = pad(d.getUTCSeconds())
    return `${y}-${m}-${day} ${hh}:${mm}:${ss} UTC`
  } catch { return iso }
}

export function formatDateTime(
  iso?: string | null,
  opts?: { timeZone?: string; locale?: string; includeSeconds?: boolean },
): string {
  if (!iso) return '-'
  try {
    const d = new Date(iso)
    const { timeZone = 'Etc/UTC', locale = 'pt-BR', includeSeconds = true } = opts || {}
    const base: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }
    const options: Intl.DateTimeFormatOptions = includeSeconds
      ? { ...base, second: '2-digit' }
      : base
    return d.toLocaleString(locale, { ...options, timeZone })
  } catch { return String(iso) }
}

export function formatDateTimeForUser(iso?: string | null, timeZone?: string | null): string {
  return formatDateTime(iso, { timeZone: timeZone || 'Etc/UTC', locale: 'pt-BR', includeSeconds: true })
}

export function formatDateTimeBR(iso?: string | null): string {
  return formatDateTime(iso, { timeZone: 'America/Sao_Paulo', locale: 'pt-BR', includeSeconds: true })
}
